import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { environment } from '../../../../environments/environment';
import { Auction } from '../models/auction';

const apiServer = environment.apiServer;

@Injectable()
export class HomeAuctionDetailService {

  constructor(private client: HttpClient) {

  }
  public get(numberAuction: string): Observable<any> {
    return this.client.get(`${apiServer}/auction/detail/${numberAuction}`);
  }

  public getDrug(numberAuction: string): Observable<any> {
    return this.client.get(`${apiServer}/auction/drug/${numberAuction}`);
  }

  public putAuction(auction: Auction) {
    return this.client.put<string>(`${apiServer}/auction/detail`, auction);
  }

  public putLog(value: string){
    const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    return this.client.put<string>(`${apiServer}/auction/log`, JSON.stringify(value), httpOptions);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/services/home-auction-detail.service.ts